// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, ApiHandler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { UpdateShipToApiParameter } from "@insite/client-framework/Services/CustomersService";
import { chain, DispatchCompleteLoadShipTo } from "@insite/client-framework/Store/Data/ShipTos/Handlers/UpdateShipTo";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";

// Add success function after the ootb updateShipTo chain to add Spinner
// The updateShipTo function is a real-time call so it takes a lot of time
type Parameter = UpdateShipToApiParameter & HasOnSuccess<ShipToModel>;

type HandlerType = ApiHandler<Parameter, ShipToModel>;

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult!);
};

addToChainAfter(chain, DispatchCompleteLoadShipTo, ExecuteOnSuccessCallback);
